<ng-container>
  <div class="position-relative">
    <input
      [minDate]="minDate"
      [maxDate]="maxDate"
      class="form-control form-control-date1 form-control-sm"
      [disabled]="disabled"
      [(ngModel)]="selected"
      (ngModelChange)="onModelChange($event)"
      [attr.placeholder]="placeholder"
      (blur)="onBlur(d1?.status)"
      ngbDatepicker
      #d1="ngModel"
      #d="ngbDatepicker"
      onkeyup="this.value=this.value
        .replace(/^(\d{2})(\d)$/g,'$1/$2')
        .replace(/^(\d{2}\/\d{2})(\d+)$/g,'$1/$2')
        .replace(/[^\d\/]/g,'')"
    />
    <button class="btn calendar" (click)="d.toggle()" type="button">
      <img class="img-invert" src="../assets/images/icons/cal-icon.png" alt="" />
    </button>
  </div>
</ng-container>